// Tilbud som blir til noe: akseptert, og videre til faktura eller ordrebekreftelse.
//
// To premisser styrer reglene her:
//
// 1. Et tilbud kan godtas på telefon, i et møte eller i en e-post. Aksept
//    registrert i appen er like gyldig som et klikk i kundelenken, men det skal
//    vaere synlig hvilken av delene det var — og en aksept kunden selv har gjort
//    skal ikke kunne viskes ut fra innsiden.
// 2. Koblingen mellom tilbudet og dokumentet det ble til er *pekeren paa
//    dokumentet*, ikke et flagg paa tilbudet. Slettes et utkast, forsvinner
//    koblingen av seg selv, og tilbudet paastaar aldri at det er fakturert.
(function initOfferConversion(global) {
  const text = (value) => String(value || '').trim();

  // Aksept uten kilde er fra kundelenken: den er eldre enn manuell aksept, og
  // hadde ingen kilde aa sette da den ble skrevet.
  const acceptanceSource = (invoice) => {
    if (!invoice || !text(invoice.offerAcceptedAt)) return '';
    return text(invoice.offerAcceptedSource) === 'manual' ? 'manual' : 'link';
  };

  const isOffer = (invoice) => {
    const kind = text(invoice?.kind);
    return kind ? kind === 'offer' : text(invoice?.type) === 'tilbud';
  };

  const canMarkAccepted = (invoice) => isOffer(invoice) && !text(invoice?.offerAcceptedAt);

  // Bare aksept som er registrert manuelt kan angres. Kunden sitt klikk er
  // dokumentasjon, og skal ikke kunne fjernes ved et uhell fra innsiden.
  const canUndoAcceptance = (invoice) => isOffer(invoice) && acceptanceSource(invoice) === 'manual';

  const conversionKind = (target) =>
    (target === 'ordre' || target === 'order_confirmation') ? 'order_confirmation' : 'invoice';

  const documentTypeOf = (invoice) => {
    const kind = text(invoice?.kind);
    if (kind === 'order_confirmation') return 'ordre';
    if (kind === 'offer') return 'tilbud';
    if (kind === 'credit') return 'kreditnota';
    return text(invoice?.type) || 'faktura';
  };

  // Dokumentene som er laget fra dette tilbudet, nyeste forst.
  const documentsFromOffer = (invoices, offerId) => {
    const id = text(offerId);
    if (!id || !Array.isArray(invoices)) return [];
    return invoices
      .filter((invoice) => text(invoice?.convertedFromInvoiceId) === id)
      .map((invoice) => ({
        id: text(invoice.id),
        num: text(invoice.invoiceNumber),
        type: documentTypeOf(invoice),
        isDraft: text(invoice.status) === 'draft',
      }))
      .sort((a, b) => Number(a.isDraft) - Number(b.isDraft));
  };

  // Grunnlaget for aa advare mot dobbeltfakturering. Et utkast er ikke det samme
  // som en faktura, men brukeren skal fortsatt faa vite at det ligger der.
  const conversionState = (documents = []) => ({
    invoiced: documents.some((document) => document.type === 'faktura' && !document.isDraft),
    confirmed: documents.some((document) => document.type === 'ordre' && !document.isDraft),
    hasDraft: documents.some((document) => document.isDraft),
  });

  global.PlummeOfferConversion = {
    acceptanceSource,
    isOffer,
    canMarkAccepted,
    canUndoAcceptance,
    conversionKind,
    documentTypeOf,
    documentsFromOffer,
    conversionState,
  };
})(typeof window !== 'undefined' ? window : globalThis);
